
import en from "./english";
import du from "./dutch";
export const LABELS = {
  en,
  du,
};
